import logo from './logo.svg';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/home';
import AttendeeDisplay from './components/attendeedisplay';
import YearDisplay from './components/yeardisplay';
import SessionDisplay from './components/sessiondisplay';
import UserDisplay from './components/userdisplay';
import WorkspaceComp from './components/workspacecomp';
import QueryContext from './components/queryContext';
import AttendanceMonitor from './components/AttendanceMonitor';

import { AuthProvider } from './components/Auth/AuthContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Login from './components/Auth/Login';

function App() {
  return (
    <AuthProvider>
        {/* <QueryContext> */}
          <Router>
            <div className="App">
              <Routes>
                <Route path="/login" element={<Login />}/>
                <Route element={<ProtectedRoute><WorkspaceComp /></ProtectedRoute>}>
                  <Route path="/" element={<Home />} />
                  <Route path="/attendees/:year/:month/:day" element={<AttendeeDisplay />} />
                  <Route path="/filter-by-year/:year" element={<YearDisplay />} />
                  <Route path="/filter-by-month/:year/:month" element={<SessionDisplay />} />
                  <Route path="/filter-by-user" element={<UserDisplay />} />
                  <Route path="/attendance-monitor" element={<AttendanceMonitor />} />
                </Route>
                {/* <Route path="/" element={<Home />} />
                <Route element={<WorkspaceComp />}>
                  <Route path="/attendees" element={<AttendeeDisplay />} />
                  <Route path="/filter-by-year" element={<YearDisplay />} />
                  <Route path="/filter-by-month" element={<SessionDisplay />} />
                  <Route path="/filter-by-user" element={<UserDisplay />} />
                </Route> */}
              </Routes>
            </div>
          </Router>
      {/* </QueryContext> */}
    </AuthProvider>
  );
}

export default App;
